// extracted by mini-css-extract-plugin
export default {"title":"title__oauLb","back":"back__ct4vt","accountSection":"accountSection__lSRJn","accountHeading":"accountHeading__tC8KF","accountLink":"accountLink__p4uFI"};